/* Based on: https://vuejsexamples.com/slim-dialog-for-vuejs/ */
<template>
  <Dialog
    ref="Dialog"
    :title="this.scopedStrings.title"
    :width=360
  >
    <div class="settings-container">

      <i class="fa fa-microchip"></i>
      <span>{{ scopedStrings.kernel }}</span>
      <select v-model="settings.current.kernel">
        <option v-for="(name, index) in settings.kernels" :key="index" :value="index">
          {{ name }}
        </option>
      </select>

      <i class="fa fa-language"></i>
      <span>{{ scopedStrings.language }}</span>
      <select v-model="settings.current.language">
        <option v-for="language in settings.languages" :key="language.id" :value="language.id">
          {{ language.name }}
        </option>
      </select>

      <i class="fa fa-paint-roller"></i>
      <span>{{ scopedStrings.theme }}</span>
      <select v-model="settings.current.theme">
        <option v-for="theme in settings.themes" :key="theme.id" :value="theme.id">
          {{ theme.name }}
        </option>
      </select>

    </div>
  </Dialog>
</template>

<script>
  import Dialog from './Dialog.vue'

  export default {
    props: {
      scopedStrings: {
        type: Object,
        required: true
      },
      settings: {
        type: Object,
        required: true
      }
    },
    components: {
      Dialog
    },
    methods: {
      show () {
        this.$refs.Dialog.show()
      }
    }
  }
</script>

<style scoped>
  select {
    background-color: var(--SettingsDialog-select-background);
    border: none;
    -moz-appearance: none;
    -webkit-appearance: none;
    color: var(--SettingsDialog-select-foreground);
    padding: 4px 0;
    text-indent: 6px;
  }

  .settings-container {
    align-items: baseline;
    display: grid;
    grid-template-columns: auto auto auto;
    grid-template-rows: auto auto auto;
    padding: 20px;
    row-gap: 6px;
  }

  .settings-container > * {
    font-size: 20px;
  }

  .settings-container > i {
    color: var(--SettingsDialog-icon-foreground);
    text-align: center;
    width: 30px;
  }

  /* Workaround for removing the black outline online on focused select tag */
  @-moz-document url-prefix() {
    select,
    select:focus {
      text-shadow: 0 0 var(--SettingsDialog-select-foreground);
    }
  }
</style>
